/* eslint-disable @typescript-eslint/no-explicit-any */

import { EventEmitter } from 'events';

class EventsHelper {
  static eventEmitter = new EventEmitter();

  emitMessage = (pKey: string, pValor: any) => {
    EventsHelper.eventEmitter.emit(pKey, pValor);
  };

  getEventEmitter = () => {
    return EventsHelper.eventEmitter;
  };
}

const instance = new EventsHelper();
export default instance;
